import { render, staticRenderFns } from "./InvoicesDetails.vue?vue&type=template&id=87db9f0e&scoped=true"
import script from "./InvoicesDetails.vue?vue&type=script&lang=js"
export * from "./InvoicesDetails.vue?vue&type=script&lang=js"
import style0 from "./InvoicesDetails.vue?vue&type=style&index=0&id=87db9f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87db9f0e",
  null
  
)

export default component.exports